import React, { useContext, useEffect, useState } from "react";
import { useHistory } from "react-router-dom";

import { CoreContext } from "context/CoreContext";
import { ReadHome, ReadHomeTabs, ReadTabCatalog, ReadTabPlaylist } from "services/catalog";
import { parseCollection } from "utils/parser";
import { Load, CenterLoad } from "ui/styled";

import CarouselBanner from "components/Dashboard/CarouselBanner";
import DashboardMenu from "components/Dashboard/Menu";
import DashboardRowVideos from "components/Dashboard/RowVideos";

import {
    PublicPage,
    PublicTopbar,
    TopLogo,
    TopActions,
    GhostBtn,
    SolidBtn,
    HelperBar,
    PublicCTA,
    CenterWrap
} from "./styled";

// Página pública de vitrine. Reaproveita os mesmos componentes e as MESMAS buscas
// públicas que a Home dos assinantes — então está sempre sincronizada com o backend.
// Diferença: é "modo visitante" (guest), e qualquer clique para assistir vai aos planos.
export default function Conteudos(){
    const history = useHistory();
    const navigate = to => history.push(`/${ to }`);
    const goPlans = () => navigate('planos');

    const { currentCategory } = useContext(CoreContext);

    const [banners, setBanners] = useState([]);
    const [tabs, setTabs] = useState([]);
    const [loading, setLoading] = useState(true);
    const [begining, setBegining] = useState(true);
    const [categoryCollections, setCategoryCollections] = useState([]);

    const init = async () => {
        const home = await ReadHome();
        const tabsResult = await ReadHomeTabs();

        if(home?.data?.attributes?.featured?.length){ setBanners(home?.data?.attributes?.featured); }
        if(tabsResult?.data?.length){ setTabs([...tabsResult?.data]); }
    };

    const initCategory = async () => {
        if((currentCategory > 0 && currentCategory < 4) && !tabs[currentCategory - 1]?.id){ return; }
        setLoading(true);
        const requests = [];
        if(currentCategory === 0){ requests.push(ReadTabPlaylist()); }
        if(currentCategory > 0 && currentCategory < 4){
            if(tabs[currentCategory - 1]?.id){ requests.push(ReadTabCatalog(tabs[currentCategory - 1]?.id)); }
        }
        const result = await Promise.all(requests);
        if(result?.[0]?.data?.length){ setCategoryCollections(result?.[0]?.data?.map(parseCollection)); }
        else { setCategoryCollections([]); }
        setLoading(false);
        setBegining(false);
    };

    useEffect(() => { if(tabs?.length){ initCategory(); } }, [currentCategory]);
    useEffect(() => { initCategory(); }, [tabs]);
    useEffect(() => {
        init();
        document.title = 'Conteúdos JoinKids — Desenhos, músicas e histórias bíblicas';
    }, []);

    return (
        <PublicPage>
            <PublicTopbar>
                <TopLogo onClick={() => navigate('')} />
                <TopActions>
                    <GhostBtn onClick={() => navigate('login')}>Entrar</GhostBtn>
                    <SolidBtn onClick={() => navigate('planos')}>Assinar</SolidBtn>
                </TopActions>
            </PublicTopbar>

            <HelperBar>👀 Você está conhecendo nosso acervo. Para assistir, é só escolher um plano.</HelperBar>

            <CarouselBanner banners={banners} guest />

            { begining ? null : <DashboardMenu tabs={tabs} guest /> }

            { loading ?
                <CenterLoad>
                    <Load white />
                </CenterLoad>
            : null }

            {
                categoryCollections?.length ?
                    categoryCollections.map((cat, kcat) =>
                        <DashboardRowVideos key={kcat} { ...cat } wrapper={categoryCollections?.length === 1} onOpen={goPlans} />
                    )
                : null
            }

            <PublicCTA>
                <h3>Gostou do que viu? 💜</h3>
                <p>Assine a JoinKids e libere todos os vídeos para o seu pequeno, num ambiente 100% seguro e sem anúncios.</p>
                <CenterWrap>
                    <SolidBtn onClick={() => navigate('planos')}>Quero assinar</SolidBtn>
                </CenterWrap>
            </PublicCTA>
        </PublicPage>
    );
}
